import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";
import { PlanFeatureFlag } from "../PlanFeatureFlag";
import { SectionWrapper } from "./SectionWrapper";

export const LiveStreams = () => (
  <SectionWrapper sectionName={t("pricing_plans.section.live_streams")}>
    <PlanFeatureFlag
      title={t("pricing_plans.feature.live_stream_max_spectator_capacity")}
      feature={planFeatures.live_stream_max_spectator_capacity}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.live_room_participants")}
      feature={planFeatures.live_room_participants_capacity}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.live_stream_hosts")}
      feature={planFeatures.live_stream_max_host_capacity}
    />
    <PlanFeatureFlag
      title={t("pricing_plans.feature.live_stream_monthly_stream_hours")}
      feature={planFeatures.live_stream_monthly_stream_hours}
    />
  </SectionWrapper>
);
